import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import RunDetail from "./pages/RunDetail";
import History from "./pages/History";
import Scorecard from "./pages/Scorecard";
import VideoStudio from "./pages/VideoStudio";
import VideoRunDetail from "./pages/VideoRunDetail";
import VideoHistory from "./pages/VideoHistory";
import VideoScorecard from "./pages/VideoScorecard";
import Layout from "./components/Layout";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center font-mono text-muted-foreground">initializing…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { borderRadius: 0, fontFamily: "JetBrains Mono" } }} />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/runs/:id" element={<Protected><RunDetail /></Protected>} />
            <Route path="/history" element={<Protected><History /></Protected>} />
            <Route path="/scorecard" element={<Protected><Scorecard /></Protected>} />
            <Route path="/video" element={<Protected><VideoStudio /></Protected>} />
            <Route path="/video/runs/:id" element={<Protected><VideoRunDetail /></Protected>} />
            <Route path="/video/history" element={<Protected><VideoHistory /></Protected>} />
            <Route path="/video/scorecard" element={<Protected><VideoScorecard /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
